import React from "react";

import GradeActiveIcon from "public/icons/grade-active.svg";
import GradeIcon from "public/icons/grade.svg";

import { ButtonWithIcon } from "@/components/form/Button/ButtonWithIcon";
import { clsxm } from "@/utils/tailwindMerge";

type PropTypes = {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isFavorite?: boolean;
  ariaLabel?: string;
  className?: string;
};

export const FavoriteButton: React.FC<PropTypes> = ({
  isFavorite = false,
  onClick,
  ariaLabel,
  className,
}) => {
  return (
    <ButtonWithIcon
      onClick={onClick}
      ariaLabel={ariaLabel}
      iconHoverColor="pink"
      disabledHover={isFavorite}
      isActive={isFavorite}
      Icon={isFavorite ? GradeActiveIcon : GradeIcon}
      className={clsxm(
        isFavorite && "!bg-white !hover:bg-white",
        "2xl:w-9 2xl:h-9",
        "bg-grey1-900 bg-opacity-40 hover:bg-grey1-900 hover:bg-opacity-40",
        "absolute right-2 top-2",
        className,
      )}
    />
  );
};
